import type { CustomRegionItem } from '@travel-planner/shared/schemas';

// `{ label, value }` options for the map's region `<Select>`.
export const toRegionOptions = (
  regions: ReadonlyArray<CustomRegionItem>
): { label: string; value: string }[] =>
  regions.map((r) => ({ label: r.title, value: r.id }));

// The selected region's boundary polygon (for the map overlay), or null.
export const findRegionBoundary = (
  regions: ReadonlyArray<CustomRegionItem>,
  regionId: string | null | undefined
): CustomRegionItem['boundaryPoints'] | null =>
  regions.find((r) => r.id === regionId)?.boundaryPoints ?? null;
